import React from 'react';

export default class Page6 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="lightgreencontentbg keyquestionpad "
                                                 style={{paddingBottom: '13px'}}>
                                                <div className="border_subtitle">‘Motivation Web’ instructions
                                                </div>
                                                <ol className="brownbullet-list listcontentSpacing listcontentbottomSpacing uiheading">
                                                    <li><p>Using the right-hand box, tick any of the statements
                                                        that clearly apply to you/your colleagues. </p></li>
                                                    <li><p>Once you’ve responded to all statements, add up the
                                                        number of ticks for each section.</p></li>
                                                    <li><p>Using the Motivation Web(s) mark each score on the
                                                        appropriate part of the 1-5 scale, treating the
                                                        innermost mark as a score of 1 and the outermost mark as
                                                        5.</p></li>
                                                    <li style={{paddingBottom: '0'}}><p> Finally, join each of
                                                        the scores together to reveal the high and low
                                                        motivators around the web. </p></li>
                                                </ol>
                                            </div>


                                            <table className="ilead_v_sport tablesrink " border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th colSpan="2" className="green_curve green_curve1"
                                                        align="left" valign="top">Section 1: Need to Achieve
                                                    </th>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">1. </span> Works
                                                            with a strong sense of urgency</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="WorksWithAStrongSenseOfUrgency"
                                                               id="WorksWithAStrongSenseOfUrgency"
                                                               onChange={this.props.handleChangePageData('achieve')}
                                                               checked={!!pageData?.achieve?.WorksWithAStrongSenseOfUrgency}/>
                                                        <label className="cursor-pointer" htmlFor="WorksWithAStrongSenseOfUrgency">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">2. </span> Is
                                                            often impatient</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="IsOftenImpatient"
                                                               id="IsOftenImpatient"
                                                               onChange={this.props.handleChangePageData('achieve')}
                                                               checked={!!pageData?.achieve?.IsOftenImpatient}/>
                                                        <label className="cursor-pointer" htmlFor="IsOftenImpatient">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">3. </span> Enjoys
                                                            competing with others</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="EnjoysCompetingWithOthers"
                                                               id="EnjoysCompetingWithOthers"
                                                               onChange={this.props.handleChangePageData('achieve')}
                                                               checked={!!pageData?.achieve?.EnjoysCompetingWithOthers}/>
                                                        <label className="cursor-pointer" htmlFor="EnjoysCompetingWithOthers">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">4. </span> Sets
                                                            self demanding targets</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="SetsSelfDemandingTargets"
                                                               id="SetsSelfDemandingTargets"
                                                               onChange={this.props.handleChangePageData('achieve')}
                                                               checked={!!pageData?.achieve?.SetsSelfDemandingTargets}/>
                                                        <label className="cursor-pointer" htmlFor="SetsSelfDemandingTargets">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">5. </span> Strong
                                                            disappointment at failure</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="StrongDisappointmentAtFailure"
                                                               id="StrongDisappointmentAtFailure"
                                                               onChange={this.props.handleChangePageData('achieve')}
                                                               checked={!!pageData?.achieve?.StrongDisappointmentAtFailure}/>
                                                        <label className="cursor-pointer" htmlFor="StrongDisappointmentAtFailure">&nbsp;</label>

                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <table className="ilead_v_sport tablesrink " border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th colSpan="2" className="green_curve green_curve1"
                                                        align="left" valign="top">Section 2: Need to Please
                                                    </th>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">1. </span> Smoothes
                                                            over conflicts in the team</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="SmoothesOverConflictsInTheTeam"
                                                               id="SmoothesOverConflictsInTheTeam"
                                                               onChange={this.props.handleChangePageData('please')}
                                                               checked={!!pageData?.please?.SmoothesOverConflictsInTheTeam}/>
                                                        <label className="cursor-pointer" htmlFor="SmoothesOverConflictsInTheTeam">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">2. </span> Co-operative
                                                            - is often looking to help others</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="CoOperativeIsOftenLookingToHelpOthers"
                                                               id="CoOperativeIsOftenLookingToHelpOthers"
                                                               onChange={this.props.handleChangePageData('please')}
                                                               checked={!!pageData?.please?.CoOperativeIsOftenLookingToHelpOthers}/>
                                                        <label className="cursor-pointer" htmlFor="CoOperativeIsOftenLookingToHelpOthers">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">3. </span> Responds
                                                            quickly to a pat on the back</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="RespondsQuicklyToAPatOnTheBack"
                                                               id="RespondsQuicklyToAPatOnTheBack"
                                                               onChange={this.props.handleChangePageData('please')}
                                                               checked={!!pageData?.please?.RespondsQuicklyToAPatOnTheBack}/>
                                                        <label className="cursor-pointer" htmlFor="RespondsQuicklyToAPatOnTheBack">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">4. </span> Takes
                                                            others' comments very much to heart</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="TakesOthersCommentsVeryMuchToHeart"
                                                               id="TakesOthersCommentsVeryMuchToHeart"
                                                               onChange={this.props.handleChangePageData('please')}
                                                               checked={!!pageData?.please?.TakesOthersCommentsVeryMuchToHeart}/>
                                                        <label className="cursor-pointer" htmlFor="TakesOthersCommentsVeryMuchToHeart">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">5. </span> Eager
                                                            to please/impress others</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="EagerToPleaseImpressOthers"
                                                               id="EagerToPleaseImpressOthers"
                                                               onChange={this.props.handleChangePageData('please')}
                                                               checked={!!pageData?.please?.EagerToPleaseImpressOthers}/>
                                                        <label className="cursor-pointer" htmlFor="EagerToPleaseImpressOthers">&nbsp;</label>

                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <table className="ilead_v_sport tablesrink " border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th colSpan="2" className="green_curve green_curve1"
                                                        align="left" valign="top">Section 3: Need to Belong
                                                    </th>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">1. </span> Sociable
                                                            and talkative</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="SociableAndTalkative"
                                                               id="SociableAndTalkative"
                                                               onChange={this.props.handleChangePageData('belong')}
                                                               checked={!!pageData?.belong?.SociableAndTalkative}/>
                                                        <label className="cursor-pointer" htmlFor="SociableAndTalkative">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">2. </span> Cohesive
                                                            in teams - pulling people together</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="CohesiveInTeamsPullingPeopleTogether"
                                                               id="CohesiveInTeamsPullingPeopleTogether"
                                                               onChange={this.props.handleChangePageData('belong')}
                                                               checked={!!pageData?.belong?.CohesiveInTeamsPullingPeopleTogether}/>
                                                       <label className="cursor-pointer" htmlFor="CohesiveInTeamsPullingPeopleTogether">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">3. </span> Adaptable
                                                            in teams</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="AdaptableInTeams"
                                                               id="AdaptableInTeams"
                                                               onChange={this.props.handleChangePageData('belong')}
                                                               checked={!!pageData?.belong?.AdaptableInTeams}/>
                                                        <label className="cursor-pointer" htmlFor="AdaptableInTeams">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">4. </span> Avoid
                                                            conflict with colleagues</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="AvoidConflictWithColleagues"
                                                               id="AvoidConflictWithColleagues"
                                                               onChange={this.props.handleChangePageData('belong')}
                                                               checked={!!pageData?.belong?.AvoidConflictWithColleagues}/>
                                                       <label className="cursor-pointer" htmlFor="AvoidConflictWithColleagues">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">5. </span> Easily
                                                            distracted by others</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="EasilyDistractedByOthers"
                                                               id="EasilyDistractedByOthers"
                                                               onChange={this.props.handleChangePageData('belong')}
                                                               checked={!!pageData?.belong?.EasilyDistractedByOthers}/>
                                                        <label className="cursor-pointer" htmlFor="EasilyDistractedByOthers">&nbsp;</label>

                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <table className="ilead_v_sport tablesrink " border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th colSpan="2" className="green_curve green_curve1"
                                                        align="left" valign="top">Section 4: Need for Autonomy
                                                    </th>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">1. </span> Often
                                                            chooses to work independently</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="OftenChoosesToWorkIndependently"
                                                               id="OftenChoosesToWorkIndependently"
                                                               onChange={this.props.handleChangePageData('autonomy')}
                                                               checked={!!pageData?.autonomy?.OftenChoosesToWorkIndependently}/>
                                                        <label className="cursor-pointer" htmlFor="OftenChoosesToWorkIndependently">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">2. </span> Manages
                                                            self - non-reliant on the support of colleagues</p>
                                                        </div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="ManagesSelfNonReliantOnTheSupportOfColleagues"
                                                               id="ManagesSelfNonReliantOnTheSupportOfColleagues"
                                                               onChange={this.props.handleChangePageData('autonomy')}
                                                               checked={!!pageData?.autonomy?.ManagesSelfNonReliantOnTheSupportOfColleagues}/>
                                                       <label className="cursor-pointer" htmlFor="ManagesSelfNonReliantOnTheSupportOfColleagues">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">3. </span> Makes
                                                            up own mind - not easily influences by others</p>
                                                        </div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="MakesUpOwnMindNotEasilyInfluencesByOthers"
                                                               id="MakesUpOwnMindNotEasilyInfluencesByOthers"
                                                               onChange={this.props.handleChangePageData('autonomy')}
                                                               checked={!!pageData?.autonomy?.MakesUpOwnMindNotEasilyInfluencesByOthers}/>
                                                        <label className="cursor-pointer" htmlFor="MakesUpOwnMindNotEasilyInfluencesByOthers">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">4. </span> Can
                                                            be distracted</p></div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="CanBeDistracted"
                                                               id="CanBeDistracted"
                                                               onChange={this.props.handleChangePageData('autonomy')}
                                                               checked={!!pageData?.autonomy?.CanBeDistracted}/>
                                                       <label className="cursor-pointer" htmlFor="CanBeDistracted">&nbsp;</label>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="94%">
                                                        <div className="paraspace"><p><span
                                                            className="subtiltereg brown boldtext numberpadding">5. </span> Prefers
                                                            to take control of situations where possible</p>
                                                        </div>
                                                    </td>
                                                    <td className="darkgreen" align="center" valign="top"
                                                        width="6%" style={{paddingLeft: '10px !important'}}>

                                                        <input type="checkbox" name="PrefersToTakeControlOfSituationsWherePossible"
                                                               id="PrefersToTakeControlOfSituationsWherePossible"
                                                               onChange={this.props.handleChangePageData('autonomy')}
                                                               checked={!!pageData?.autonomy?.PrefersToTakeControlOfSituationsWherePossible}/>
                                                        <label className="cursor-pointer" htmlFor="PrefersToTakeControlOfSituationsWherePossible">&nbsp;</label>

                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page5')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div
                                                onClick={this.props.savePageData('Page7')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}